export default "__VITE_ASSET__u5ltF_ls__";